/* eslint-disable vue/require-v-for-key */
/* eslint-disable vue/require-default-prop */

<script>
import Produto from '@src/services/produto_estoque'
import Loading from 'vue-loading-overlay'
import { VMoney } from 'v-money'

import tipoProdutoService from '../services/api-receituario/tipo-produto'
import unidadeService from '../services/api-receituario/unidade'

import serviceProduto from '@/src/services/produto'

export default {
  components: {
    Loading,
  },
  directives: { money: VMoney },
  props: {
    produto: {},
  },
  data() {
    return {
      is_defensivo: false,
      show: false,
      mensagems: null,
      sucesso: null,
      classes_toxicologicas: [],
      empresas: [],
      unidades: [],
      tipos_produto: [],
      mapas: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      mapasFields: [
        {
          key: 'nome',
          label: 'Nome',
          class: 'size-col-20',
        },
        {
          key: 'mapa',
          label: 'Mapa.',
          class: 'size-col-20',
        },
      ],
      rows: 1,
      filter: null,
      isLoading: false,
    }
  },
  created() { },
  mounted() {
    this.handleGet()
    this.handleGetTiposProduto()
    this.handleGetUnidade()

    this.is_defensivo = this.produto.mapa != undefined ? true : false
    this.rows = this.mapas.length
  },
  methods: {
    loading(a) {
      a = !this.isLoading
      return a
    },
    onFiltered(filteredItems) {
      this.rows = filteredItems.length
      this.currentPage = 1
    },
    modalShow() {
      if (this.show === true) {
        this.show = false
      }
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      serviceProduto.listar(token).then((response) => {
        this.mapas = response.data.dados
      })
    },
    salvarProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.produto.desc_antidoto_tratamento = ''
      this.produto.desc_precaucao_uso = ''
      this.produto.desc_epi = ''
      this.produto.desc_primeiro_socorro = ''
      this.desc_primeiro_socorro = ''
      if (this.produto.id_produto) {
        this.isLoading = this.loading(this.isLoading)
        Produto.update(token, this.produto)
          .then((resposta) => {
            this.$bvToast.toast('Atualizado com sucesso', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.data.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(false)
          })
      } else {
        this.isLoading = this.loading(this.isLoading)
        Produto.salvar(token, this.produto)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.mensagem, {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            }
            this.produto.id_produto = resposta.data.sucesso.idProduto
            this.produto.is_register = false
            this.$emit('onSave', { produto: this.produto })
            this.produto = {}
          })
          .catch((erro) => {
            this.isLoading = this.loading(this.isLoading)
            this.$bvToast.toast(
              erro.response
                ? erro.response.data.data.join(', ')
                : 'Erro inesperado',
              {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              }
            )
            this.isLoading = this.loading(false)
          })
      }
    },
    handleGetTiposProduto() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      tipoProdutoService.listar(token).then((response) => {
        this.tipos_produto = response.data.tipos
        this.isLoading = this.loading(this.isLoading)
      })
    },

    handleGetUnidade() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      unidadeService.listar(token).then((response) => {
        this.unidades = response.data.unidades
        this.isLoading = this.loading(this.isLoading)
      })
    },
  },
}
</script>

<template>
  <div>
    <b-form>
      <div class="row">
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Nome" label-for="input-1">
            <b-form-input id="input-1" v-model="produto.nome" type="text" placeholder="Nome do produto"
              required></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-3">
          <b-form-group id="input-group-1" label="EAN" label-for="input-1">
            <b-form-input id="input-1" v-model="produto.ean" type="text" placeholder="Código de barras do produto"
              required></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group id="input-group-1" label="Data de entrada" label-for="input-2">
            <b-form-datepicker id="datepicker-inicial" v-model="produto.data_cadastro" placeholder="Selecione a data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }" locale="pt-br">
              <template v-slot:button-content>
                <b-icon icon="calendar" variant="primary"></b-icon>
              </template>
            </b-form-datepicker>
          </b-form-group>
        </div>
        <div class="col-md-1">
          <b-form-group label="Defensivo">
            <b-form-checkbox v-model="is_defensivo" switch />
          </b-form-group>
        </div>
        <div class="col-md-1">
          <b-form-group label="Ativo">
            <b-form-checkbox v-model="produto.ativo" switch />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <b-form-group label="Tipo do Produto" label-for="input-1">
            <v-select class="style-select" :options="tipos_produto" :reduce="(item) => item.id" label="nome"
              v-model="produto.id_tipo_produto" @input="$forceUpdate()">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Unidade" label-for="input-1">
            <v-select class="style-select" :options="unidades" :reduce="(item) => item.id" label="unid1"
              v-model="produto.id_unidade" @input="$forceUpdate()">
            </v-select>
          </b-form-group>
        </div>
        <div class="col-md-2">
          <b-form-group label="Peso/Volume" label-for="input-volume">
            <b-form-input id="input-volume" v-model="produto.volume" type="text" placeholder="Peso/Volume" required>
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4" v-show="is_defensivo">
          <b-form-group id="input-mapa" label="M.A.P.A" label-for="input-mapa">
            <b-form-input id="input-mapa" v-model="produto.mapa" type="text" placeholder="Código do M.A.P.A do produto"
              required>
            </b-form-input>
            <template slot="label">
              M.A.P.A
              <b-link @click="$bvModal.show('modal-mapa')">Ver códigos</b-link>
            </template>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Valor de venda">
            <b-form-input v-model.lazy="produto.valor_venda" v-money="money" />
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Custo médio">
            <b-form-input v-model.lazy="produto.custo_medio" v-money="money" />
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Estoque disponível" label-for="input-1">
            <b-form-input id="input-1" v-model="produto.estoque_disponivel" type="number"
              placeholder="Estoque disponível" required
              :disabled="produto.id_produto == undefined ? disabled : ''"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Estoque mínimo" label-for="input-1">
            <b-form-input id="input-1" v-model="produto.estoque_minimo" type="number" placeholder="Estoque mínimo"
              required :disabled="produto.id_produto == undefined ? disabled : ''"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-1" label="Estoque máximo" label-for="input-1">
            <b-form-input id="input-1" v-model="produto.estoque_maximo" type="number" placeholder="Estoque máximo"
              required :disabled="produto.id_produto == undefined ? disabled : ''"></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-group id="input-group-1" label="Cód. Integração ERP" label-for="input-1">
            <b-form-input id="input-1" v-model="produto.cod_erp" type="text" placeholder="Cód. Integração ERP"
              ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-form-group label="Observações">
            <b-form-textarea id="textarea" v-model="produto.obs" placeholder="Informações extras..." rows="6"
              max-rows="6"></b-form-textarea>
          </b-form-group>
        </div>
      </div>
      <b-modal id="modal-mapa" title="Relação Códigos de M.A.P.A" title-class="font-18">
        <b-form-group id="input-filter-mapa" label="Pesquisar Produto" label-for="filter">
          <v-select class="style-select" label="nome" :options="mapas" :reduce="(mapa) => mapa.nome" v-model="filter"
            :dense="true"></v-select>
        </b-form-group>
        <b-table striped hover responsive="sm" borderless bordered outlined small :items="mapas" :fields="mapasFields"
          :filter="filter">
        </b-table>
        <template v-slot:modal-footer>
          <b-button variant="primary" @click="$bvModal.hide('modal-mapa')">OK</b-button>
        </template>
      </b-modal>
      <b-button type="submit" variant="primary" @click.prevent="salvarProduto">Salvar</b-button>
    </b-form>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </div>
</template>

<style scoped>
input[disabled],
input[disabled]:hover {
  background: #dddddd;
}
</style>